import { Search } from "@icons/untitled_ui_icons";
import { TextInput, TextInputProps } from "@src/components/ui-components/Inputs/TextInput/TextInput";
import { GenericComponentProps, makeStyles } from "@src/utils/genericComponentProps";
import { t } from "i18next";
import { CSSProperties } from "react";

type Props = GenericComponentProps & Omit<TextInputProps, "iconBefore">;

/**
 * SearchInput component is a text input field that is used to search for items in a list.
 */
export const SearchInput = ({ value, onChange, placeholder, ...props }: Props) => {
  const cssStyles: CSSProperties = makeStyles(props);

  return (
    <TextInput {...props} style={cssStyles} value={value} placeholder={placeholder ?? t("main.search")} onChange={onChange} iconBefore={Search} />
  );
};
